import React from 'react';
import useRequestInfo from '../hooks/useRequestInfo';
import EditorDetails from 'components/details/EditorDetails';

const ShareOverview = () => {
    const { displayData, loading, error } = useRequestInfo();

    return (
        <div className="text-true-blue">
            <h3 className="text-2xl font-bold">Request information</h3>
            <EditorDetails
                loading={loading}
                error={error}
                items={{ data: displayData }}
                type="dataset"
                hideDescription
            />
        </div>
    );
};
export default ShareOverview;
